// name => table name (store name)
// keyPath => column that will be the key

export const storesDB = {
    settings: {
        name: 'settings',
        keyPath: 'code',
        columns: {
            NotificationPrivateKey: 'NotificationPrivateKey'
        }
    }
}